    <template>
        <div class="loader" v-bind:class="{ 'off': !loading }">
            <div class="lds-circle"></div>
        </div>
    </template>

    <script>
    import { mapGetters } from "vuex";

    export default {
        name: 'loader-template',
        computed: {
            ...mapGetters({
                loading: "getLoading"
            })
        }  
    }
    </script>
    
    <style scoped lang="less">
    .loader {
        height: 100%;
        width: 100%;
        background: #252C33;
        position: fixed;
        z-index: 9999;
        top: 0;
        text-align: center;
     -webkit-transition: display 0.5s ease-in;
       -moz-transition: display 0.5s ease-in;
        -ms-transition: display 0.5s ease-in;
         -o-transition: display 0.5s ease-in;
            transition: display 0.5s ease-in;
            
        &.off {
            // opacity: 0;
            display: none;
        }
    }

 .lds-circle {
    position: relative; 
    top: 43%;
    display: inline-block;
    width: 51px;
    height: 51px;
    margin: 6px;
    border-radius: 50%;
    background: #fff;
    animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }
    @keyframes lds-circle {
    0%, 100% {
        animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
    }
    0% {
        transform: rotateY(0deg);
    }
    50% {
        transform: rotateY(1800deg);
        animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
    }
    100% {
        transform: rotateY(3600deg);
    }
}
</style>
    


// WEBPACK FOOTER //
// src/components/layout/TheLoader.vue